<ngx-editor-menu [editor]="editor" [toolbar]="toolbar">
</ngx-editor-menu>

<ngx-editor [editor]="editor" [ngModel]="value" [disabled]="disabled" (ngModelChange)="onValueChange($event)"
    [placeholder]="placeholder" class="ant-input"></ngx-editor>

